import { PDxListItem } from "src/app/core/PDxListItem.model";
import { PDxUserPermission } from "src/app/core/PDxUserPermission.enum";

export class UserAssignmentInformation {
    constructor() {
        this.hierarchy = [];
        this.passToChildren = true;
        this.permissions = [];
    }

    entityId: string;
    userId: string;
    hierarchy: PDxListItem<string>[];
    passToChildren: boolean;
    permissions: PDxListItem<PDxUserPermission>[];
}